// extracted by mini-css-extract-plugin
export default {"quantityVisitsDetails":"StatsCoaches_quantityVisitsDetails__GWvmq","pointer":"StatsCoaches_pointer__TLHa2"};